module.exports = __webpack_public_path__ + "static/media/9.7ccb3bdd.jpg";